import { Button, Modal, Checkbox, message } from "antd";
import React, { useEffect, useState } from "react";
// import { Quantity } from "../Cart/Products";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { season_icons } from "../../../components/ShopForTyres";
import { UploadProdImg, upload_product_img } from "../../actions/admin/Action";
import { Products } from "../../actions/orders";
import Close from "../../assets/cancel.svg";
import trash from "../../assets/trash.svg";
import Tyre from "../../assets/coming-soon.jpg";
import { apis } from "../../config/apis";
import endpoint from "../../config/endpoint";
import { NavWrap } from "../ShopForTyres";
import "../styles/order.css";
// import Product360View from "./Prod360View";

const ProductDetails = () => {
  const history = useHistory();
  const [product, setProduct] = useState({});
  const [selectedImgIdx, setSelectedImgIdx] = useState(0);
  const [delModal, setDelModal] = useState(0);
  const [delArr, setDelArr] = useState([]);
  const [delLoading, setDelLoading] = useState({});
  const location = useLocation();

  const uploadImg = useSelector((state) => state?.admin?.uploadImg);
  const dispatch = useDispatch();
  useEffect(() => {
    if (location?.state?.product) setProduct(location?.state?.product);
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    if (uploadImg?.success) {
      toast.success("Product image uploaded.");
      dispatch({
        type: UploadProdImg.RESET,
      });
      history.push("/admin/products")
    }
    if (uploadImg?.success === false) {
      toast.error("Failed to upload product image.");
      dispatch({
        type: UploadProdImg.RESET,
      });
    }
    // eslint-disable-next-line
  }, [uploadImg]);

  const onDelete = (id) => {
    setDelLoading({ one: true })
    endpoint.post(apis.admin.product_delete, {
        admin: true,
        email: localStorage.getItem("email"),
        product_id: product?.id,
        image_ids: [id, ...delArr]
    }).then((res) => {
      if (res.data) {
        toast.success("Deleted Successfully.")
        setDelLoading({ one: false })
        setDelArr([])
        history.push("/admin/products")
      }
    }).catch(err => {
      console.log(err);
      setDelLoading({ one: false })
    })
  }

  const onDeleteAll = (id) => {
    setDelLoading({ all: true })
    endpoint.post(apis.admin.bulk_prod_delete, {
        admin: true,
        email: localStorage.getItem("email"),
        product_id: "",
        image_ids: [id, ...delArr],
        pattern: product?.pattern
    }).then((res) => {
      if (res.data) {
        toast.success("Deleted Successfully.")
        setDelLoading({ all: false })
        dispatch({ type: Products.RESET })
        setDelArr([])
        history.push("/admin/products")
      }
    }).catch(err => {
      setDelLoading({ all: false })
      console.log(err);
    })
  }

  const sortedFileNames = (a, b) => {
    // Extract numeric parts and convert to integers
    let numA = parseInt(a?.name?.match(/\d+/)?.[0], 10);
    let numB = parseInt(b?.name?.match(/\d+/)?.[0], 10);

    return numA - numB;
  };

  return (
    <NavWrap>
      <div className="cart">
        <span className="close">
          <img
            src={Close}
            className="cursor"
            alt="close"
            onClick={() => {
              history.push("/admin/products", {
                filters: location.state?.filters
              });
            }}
          />
        </span>
        <div className="order-detail">
          <Modal visible={delModal} maskClosable={false} footer={[
            <Button key="delete" loading={delLoading?.one} disabled={delLoading?.one || delLoading?.all} type="danger" onClick={() => onDelete(delModal)}>
              Delete
            </Button>,
            <Button key="deleteAll" loading={delLoading?.all} disabled={delLoading?.one || delLoading?.all} type="danger" onClick={() => onDeleteAll(delModal)}>
              Delete All
            </Button>,
          ]}
            title="Delete Confirmation" onCancel={() => {
              if (delLoading?.one || delLoading?.all) {
                message.warn("Deleting the images, please wait.")
                return;
              }
              setDelModal(false)
            }}>
            <div>
              Are you sure you want to delete this image ?
            </div>
            <div className="mtHalf note">
              Note: Clicking 'Delete All' will remove this image from products sharing the same pattern.
            </div>
            <br />
            <div className="other_imgs">
              <div>
                Would you like to delete any other images ?
              </div>
              <div className="flex-wrap">
                {product?.images?.map(ele => {
                  return ele.id !== delModal ? <div className="flex-center">
                    <Checkbox onChange={(e) => {
                      if (e.target.checked) {
                        setDelArr([...delArr, ele.id])
                      } else {
                        let idx = delArr.indexOf(ele.id)
                        delArr.splice(idx, 1)
                        setDelArr(delArr)
                      }
                    }} />
                    <img src={ele.url} width={50} alt="" />
                  </div> : null
                })}
              </div>
            </div>
          </Modal>
          <div className="d-flex gap1">
            <div className="w50 left">
              <div className="d-flex gap1">
                <div className="w15">
                  {product?.images?.sort(sortedFileNames)?.map((ele, i) => (
                    <span
                      className={selectedImgIdx === i ? "active p-relative" : "p-relative"}
                      onClick={() => {
                        setSelectedImgIdx(i);
                      }}
                    >
                      <img src={ele.url ? ele.url : Tyre} alt="tyre" />
                      <img src={trash} alt={"alt"} width={14} className="ml1 cursor img-abs" style={{ marginTop: -2 }} onClick={() => {
                        setDelModal(ele.id)
                      }} />
                    </span>
                  ))}
                </div>
                <div className="w85">
                  <span>
                    <img
                      src={
                        product?.images?.[selectedImgIdx]?.url
                          ? product?.images?.[selectedImgIdx]?.url
                          : Tyre
                      }
                      alt="tyre"
                    />
                  </span>
                </div>
              </div>
              <div className="flex-center">
                <input
                  id="file"
                  className="d-none"
                  type={"file"}
                  multiple
                  onChange={(e) => {
                    let formData = new FormData();
                    for (let i = 0; i < e.target.files.length; i++) {
                      formData.append("files[]", e.target.files[i]);
                    }
                    formData.append("email", localStorage.getItem("email"));
                    formData.append("product_id", product?.id);
                    dispatch(upload_product_img(formData));
                  }}
                />
                <button
                  className="upload-btn mt1"
                  onClick={() => {
                    let file = document.getElementById("file");
                    file.value = "";
                    file.click();
                  }}
                  disabled={uploadImg?.loading}
                >
                  {uploadImg?.loading ? "Uploading..." : "Upload Images"}
                </button>
              </div>
            </div>
            <div className="w50 right">
              <div className="ml2">
                <div className="head-sec">
                  <span>{product?.brand}</span>
                  <strong>{product?.pattern}</strong>
                  <span className="dim">Product SKU : {product?.sku}</span>
                </div>
                {/* <div className="price-sec">
                  <strong>${product?.unit_price}</strong>
                  <span className="tag">
                    Price tag : Will be extracted from Price Master
                  </span>
                </div> */}
                <div className="selected-rim">
                  <div>
                    <label>Selected Rim</label>
                    {/* <span>Size Chart</span> */}
                  </div>
                  <button className="primary-btn">{product?.rim}''</button>
                </div>
                <hr />
                <div className="selected-rim flex-start mb1">
                  <button className="primary-btn">{product?.size}</button>
                  {/* <span>See more tyre size</span> */}
                </div>
                {/* <div className="selected-rim flex-start">
                  <Quantity fromDetail={true} data={product} />
                </div> */}
                <div className="product-detail mt2">
                  <h3>Product Detail</h3>
                  {/* <p>
                    {product?.images?.length > 0 &&
                      <Product360View images={(product?.images?.sort(sortedFileNames)?.map((ele) => Array.from({ length: 100 }, () => ele.url)))?.flat()} />}
                  </p> */}
                  <ul>
                    <li><strong className="mrHalf">Season:</strong><img className={`season-img ${product?.season?.trim()?.toLowerCase()}`} src={season_icons[product?.season?.trim()?.toLowerCase()]} alt="" /></li>
                    <li><strong className="mrHalf">Application:</strong>{product?.application}</li>
                    {/* <li><strong className="mrHalf">Group:</strong>{product?.mtr_group}</li> */}
                    <li><strong className="mrHalf">EAN:</strong>{product?.ean}</li>
                    <li><strong className="mrHalf">SW:</strong>{product?.sidewall}</li>
                    {/* <li><strong className="mrHalf">Size:</strong>{product?.size}</li> */}
                    <li><strong className="mrHalf">Pattern:</strong>{product?.pattern}</li>
                    <li><strong className="mrHalf">LI:</strong>{product?.li}</li>
                    <li><strong className="mrHalf">SR:</strong>{product?.sr}</li>
                    <li><strong className="mrHalf">LR:</strong>{product?.lr}</li>
                    <li><strong className="mrHalf">Brand:</strong>{product?.brand}</li>
                    {/*                     
                    <li><strong className="mrHalf">Warranty:</strong>{product?.rh_warranty}</li>
                    <li><strong className="mrHalf">Guarantee:</strong> {product?.s_guarantee}</li> */}
                    <li>{product?.certifications}</li>
                    {/* <li>SUV / Light Truck</li>
                    <li>Mud and Snow</li> */}
                  </ul>
                  {/* <ul className="links">
                    <li>Limited Warrent</li>
                    <li>Contact Us</li>
                  </ul> */}
                </div>
                {/* <div className="tabs mt1">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Description" key="1">
                      <p>
                        The Patriot A/T is an all-terrain tyre that has been
                        designed for on and off-road use. This range offers
                        steering stability and traction in mud and snow
                        conditions while maintaining good on-road performance as
                        well.
                        <br />
                        <br />
                        The Patriot A/T is an all-terrain tyre that has been
                        designed for on and off-road use. This range offers
                        steering stability and traction in mud and snow
                        conditions while maintaining good on-road performance as
                        well.
                      </p>
                    </TabPane>
                    <TabPane tab="Sizes" key="2">
                      Content of Tab Pane 2
                    </TabPane>
                    <TabPane tab="Specification" key="3">
                      Content of Tab Pane 3
                    </TabPane>
                    <TabPane tab="Warrenty" key="4">
                      Content of Tab Pane 4
                    </TabPane>
                  </Tabs>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </NavWrap>
  );
};

export default ProductDetails;
